__turbopack_context__.v({
  "className": "avertalightitalic_12ece88d-module__hNoxbq__className",
  "variable": "avertalightitalic_12ece88d-module__hNoxbq__variable",
});
